/**
 * ANQ.ContentServiceManagement.API 
 * Content Service Mgt API
 *
 * OpenAPI spec version: v1
 * Contact: support@coure-tech.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface AddressBookContact { 
    _id?: string;
    id?: number;
    addressBookId?: string;
    contact?: string;
    dateUpdated?: Date;
    dateAdded?: Date;
}